<template>
    <section > 
  <section 
  class="drop-container" 
  style="display:flex;width: 80%;"
  @drop="onDrop" @dragover="onDragOver">
    <section
      class="droped-signature"
      style="height: 100vh;width: 100%;  background-color: bisque"
     
    >
      Signature Drop Area
      <span v-if="isSignaturePad">
        <signature-pad
          @signature-image="getSignatureImage"
          @signature-data="getSignatueCanvas"
          @emit-signature="getSignature"
          @emit-signature-font="getSignatureFont"
          @close-signature="isSignaturePad = false"
        ></signature-pad>
      </span>
    </section>
    <section
      class="droped-signature"
      style="height: 100vh;background-color: skyblue;width: 100%;"
     
    >
      Signature Drop Area 2
    </section>
</section>
    <div id="app" style="width: 20%;">
      <div
        v-for="item in items"
        :key="item.id"
        draggable="true"
        @dragstart="dragStart(item)"
        @dragover.prevent
        @drop="drop(item)"
      >
        {{ item.title }}
      </div>

      <div style="margin-bottom: 12px">
        <hlxselect
          :options="signatureList"
          :placeholder-value="'Choose approvers'"
          :label-animation="true"
          :label="'name'"
          :clearable="true"
          @custom-change="returnOptions"
          @selected-value="returnSelectedObject"
        />
      </div>

      <section>
        <section
          draggable="true"
          class="drag-signature"
          @dragstart="onDragStart"
          @dragend="onDragEnd"
        >
          Signature
        </section>
        <section class="drag-signature">Date</section>
      </section>
    </div>
  </section>
</template>

<script>
import hlxselect from "../components/SelectComponent.vue";
import SignaturePad from "../components/SignaturePad.vue";
export default {
  components: {
    hlxselect,
    SignaturePad,
  },
  data() {
    return {
      currentSignatureElement: "",
      signature: "",
      isSignaturePad: false,
      draggedItem: null,
      signatureList: [
        { id: 1, name: "Mia Jackson" },
        { id: 2, name: "John Wick" },
        { id: 3, name: "Alan Richard" },
      ],
      items: [
        { id: 1, title: "Item 1" },
        { id: 2, title: "Item 2" },
        { id: 3, title: "Item 3" },
      ],
    };
  },
  methods: {
    getSignatureImage(val){
        console.log("getSignatureImage from view",val)
        this.signatureBase=val
        // this.signatureBase='data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIAKgAswMBIgACEQEDEQH/xAAcAAEAAwADAQEAAAAAAAAAAAAABgcIAgQFAwH/xABDEAACAQMCAwUCCgYJBQAAAAAAAQIDBAUGEQchMRJBUWFxE4EIFBUiMkKCkaGyIzNSYpKxFiRkcnOiwcLhJSY0U2P/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AvEAAAAAAAAAAAAAAI5qvW+n9J0/+r30Y13HeFrSXbqy+yui83svMCRgojM8frmU5RweEpQgvo1Lyo5N+sY7bfxMuLSmSrZjTOLyV1GEa93a061RU01FSlFN7b78gPVAAAAAAAAAAAAAAAAAAAAAAAAAIjxR1Z/RDSle8otfHq79haRf7bX0vspN+qS7wInxc4pvAzng9OzjLJbbXFz1Vvv8AVXjP8F69M93NxWuq87i6rVK1ao+1OpUk5Sk/Ft82catWpWqzq1pyqVJycpzm93Jvq2+9nADlCEqk4wpxcpye0YxW7b8EbR0/j/knA43Hb7/FLWlRb8XGKW/4GdOB2kp57VNPJ3FN/J+Lkqsm1ynV+pFej+c/ReJpsAAAAAAAAAAAAAAAAAAAAD5c2eFf6y0xjqkqd5n8bTqQe0qfxmLlH1inuB7oIzb8QdIXEuzT1Hjk/wD6VlBffLYkdGtSuKcatCpCpTl0nCSafvQHMzn8IrLTutWWmMUv0NjbKXZ8Kk3u/wDKoGjCg+JfDXVWodfZHI4zHwnZXHsuxXncU4rlShF7rftdU+4CmCQaK0jktY5eNjjYdmnHZ3FzJfMoR8X59dl3/e1ZmmuAteVWNXU2Spwpp7u3st3KXrOS5e5P1Lbtoac0XiqdpCrY4myj9FVasYdp+LcnvJ+b3YH20vp+w0xhbfFYyDjRpLnKX0qkn1lJ+L/46I9YhdzxV0PbVHTqZ6lKS/8AVQq1F98YtHasOI+jb/8AUahsY/483R/OkBKgcKNalXpxq0KkKlOXScJJp+9HMAAAAAAAAAAAAAAEA4h8UsXpDt2VtGN/ltv/AB4y2jS375y7vHsrn6b7nV4x8QXpPHxxuLmvli7g2pdfi9Pp29vF80vRvu2eaKtSdarOrVnKdScnKU5Pdyb6tvvYEi1RrvUeqKk/lTI1Pi8ulrRfYpJeHZXX1e7I0AAPQw+cyuEre2xGRubOe+79jUcVL1XR+888AW1p7jtnLJRpZyyt8lTXJ1Yfoavq9k4v7kSi84/YeNr2rLDX9S52+hWlCEE/7ybf4GfQBYeo+MWq8yp0ra4p4y3luuzZrae3nN7vfzWxAbm4r3Vede6rVK1ab3lUqScpSfm2fIAAAB6WEz+XwFx7fD5G4tJ77tUp7Rl/ej0l70Xfw9400MjVp47VkaVrcS2jTvofNpTf76+o/Pp6GfgBuNc+aBXHA96lhpWNDUFvKFnT2+T515P2rp/suPXsr6u/d05bFjgAAAAAAAADq5S/oYrG3WQu5dm3taUqtRrr2Yrd7eZ2isfhB5aVhomFjTltPIXMacufPsR+e/xUV7wM+akzV1qHOXmWvpb1rmo5bb7qEekYryS2XuPNAAAAAAAAAAAAAAABenBbhpRlQt9T6goqo5pTsbaa5Jd1WS72/qr3+G1Z8NdOLVGsbDHVYuVqpOtc/wCHHm173tH7RrqMYwiowSjFLZJLZJAfoAAAAAAAAAAFDfCWuXLIYK13e0KVap/E4r/aXyZ8+Emv+4sQ/wCxy/OwKfAAAAAAAAAAAAAAABc/warSE8rm71x/SUaFKlF+CnJt/kRfhRHwZ6sVdagot/OnToSS8k5p/mRe4AAAAAAAAAAACi/hL2zVXAXajyca9OT8Nuw1/Nl6FZ/CCx3xzQfxuPWxuqdVv92W8P5yiBmgAAAAAAAAAAAAAAAE94J5yGE17aRrSUaF/B2k230ctnH/ADRiveamMOxbjJSi2mnumu41Jwl15R1dho2t3VSzNnTSuIPk6sVy9qvXv26PyaAnwAAAAAAAAAAHnajxcM3gchi6jSjd286Sk/qtrk/c9n7j0QBiC4o1bavUoV4OFWlNwnB9YyT2aPmWPx1058iaznfUafZtMpF14tLZe06VF677S+2VwAAAAAAAAAAAAAADt4vJXuIyFG/xtzUtrqhLtU6tN80/9V3NPk0dQAaR0JxkxGZpU7TUU6eMyCWzqSe1Cq/FSf0PSXLzZaMZKUVKLTi1umujMeaEwEtTasx2K7LdKrVUq7XdSjznz7uSaXm0bDjFRioxSUUtkkuSA/QAAAAAAAAABD+KmlP6W6SuLWhBO+t/09o/GaXOP2luvXZ9xk2UXGTjJNST2afcbiM88d9CvGZCWpcbS/qV3P8ArcIx5Uqr+t6S/N6oCogAAAAAAAAAAAAAAl/DLRtbWWooW8lKOPt9ql5VXdDflFP9qWzS977gLX+D5pR47D1tRXlPs3F+uxbqS5xop839qS+6KfeW6cKFGnb0KdChTjTpU4qEIRWyjFLZJLwOYAAAAAAAAAAADr39lbZGyr2V7RjWtq8HCpTl0lF9TsADJnEnQt3orLum+3Wxtdt2ly11X7Mv3l+PXyUPNqZvD2GextbHZW3jcWtVbShLufc0+5rxRn3WPBbOYmtOtp9PKWPVRTUa8F4OPSXrHr4ICrQe5T0bqipUVOGnMv2t9tnZVFt68uRMdPcEtUZKUZZP2GKob83VkqlTbxUYv+bQFZA01hOCmk8fGLvoXOSqrZuVeq4R38ow25eTbJLHQWkYw7K05jNvO3i394GQAanzHCHRuTjLsY6VlVa/WWlVw2+y94/gVrqTgTmLSU6un72jf0ubVGs/ZVfJJ/RfrugKiBJLzQWrrOt7KtpzJyl40beVWP8AFDdHtab4RaszVWm7iy+TLaWzlWvPmyS8ofS38ml6oCJ6ewd/qLLUMZiqLq3FZ/Zgu+Un3JeJrLRGlrPSGAo4yz2nNfOuK+2zrVH1k/5JdySPhobROJ0Xj3b46DqXFT9fd1Eu3Vf+kfBL8XzJMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH//Z'
        let img = document.createElement("img");
      img.src = this.signatureBase;
      img.style.position = "absolute";
      img.style.objectFit="contain"
      img.alt = "Signature"; 
      img.style.width = "150px";
      img.style.height = "45px";
      console.log("getSignatureCanvas Signature updated:", val);

      if (this.currentSignatureElement) {
        this.currentSignatureElement.innerHTML = "";
        this.currentSignatureElement.appendChild(img);
      } else {
        console.log("No currentSignatureElement found.");
      }
      
      this.currentSignatureElement.addEventListener("click", this.onSignatureClick);
      console.log("getSignatueCanvas Signature updated:", val);
    },
    onDragStart(event) {
      console.log(event.target.className, "Drag start", event);
      event.dataTransfer.setData("text/plain", event.target.className);
    },
    onDragEnd(event) {
      console.log("Drag ended", event);
    },
    dragStart(item) {
      this.draggedItem = item;
    },
    drop(item) {
      const indexItem = this.items.indexOf(item);
      const indexDragged = this.items.indexOf(this.draggedItem);
      this.items.splice(indexItem, 0, this.items.splice(indexDragged, 1)[0]);
    },
    onDragOver(event) {
      event.preventDefault();
    //   console.log(event)
    },
    onDrop(event) {
      event.preventDefault();
      const dropTargetUpdated = event.target.closest(".droped-signature");
      const draggedClass = event.dataTransfer.getData("text");
      const dropTarget = event.target;
      const dropTargetClass = dropTarget.className;

      console.log(dropTargetClass, "onDrop", draggedClass);
      if (dropTargetClass && !dropTargetClass.includes("drag-signature")) {
        const draggedElement = document.querySelector(`.${draggedClass}`);
        if (draggedElement) {
          const dropTargetRect = dropTarget.getBoundingClientRect();
          const clone = draggedElement.cloneNode(true);
          console.log("Cloned element:", clone);

          const cloneWidth = 180;
          const cloneHeight = 45;
          const initialLeft = Math.max(
            0,
            Math.min(
              event.clientX - dropTargetRect.left,
              dropTargetRect.width - cloneWidth
            )
          );
          const initialTop = Math.max(
            0,
            Math.min(
              event.clientY - dropTargetRect.top,
              dropTargetRect.height - cloneHeight
            )
          );
          clone.style.zIndex='9999'
          clone.style.position = "absolute";
          clone.style.width = `${cloneWidth}px`;
          clone.style.height = `${cloneHeight}px`;
          clone.style.margin = "0";
          clone.style.left = `${initialLeft}px`;
          clone.style.top = `${initialTop}px`;

          clone.addEventListener("mousedown", this.onMouseDown);
          clone.addEventListener("click", this.onSignatureClick);
          
          dropTargetUpdated.appendChild(clone);
        }
      } else {
        console.log("Cannot drop here!");
      }
    },
    onMouseDown(event) {

    //   event.preventDefault();
    console.log("onMouseDown",event)
      const clone = event.target;
      if (clone.style.position !== "absolute") {
        clone.style.position = "absolute";
      }

      const offsetX = event.clientX - clone.getBoundingClientRect().left;
      const offsetY = event.clientY - clone.getBoundingClientRect().top;

      const dropTarget =  document.querySelector(".drop-container");
      const dropTargetRect = dropTarget.getBoundingClientRect();
    //   const container = document.querySelector(".drop-container");
    //   const containerRect = container.getBoundingClientRect();
      const onMouseMove = (moveEvent) => {
        clone.style.position = "absolute";
        let newLeft = moveEvent.clientX - offsetX - dropTargetRect.left;
        let newTop = moveEvent.clientY - offsetY - dropTargetRect.top;

        newLeft = Math.max(
          0,
          Math.min(newLeft, dropTargetRect.width - clone.offsetWidth)
        );
        newTop = Math.max(
          0,
          Math.min(newTop, dropTargetRect.height - clone.offsetHeight)
        );

        clone.style.left = `${newLeft}px`;
        clone.style.top = `${newTop}px`;
      };

      const onMouseUp = () => {
        // clone.style.position = "relative";
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
      //   clone.style.position = 'relative';
    },
    onSignatureClick(event) {
      this.isSignaturePad = true;
      console.log("Signature clicked:", event.target);
      this.currentSignatureElement = event.target;
    },
    getSignature(val) {
      if (this.currentSignatureElement) {
        this.currentSignatureElement.innerHTML = val;
        console.log("Signature updated:", val);
      }
    },
    getSignatueCanvas(val) {
      let img = document.createElement("img");
      img.src = val;
      img.style.position = "absolute";
      img.alt = "Signature"; 
      img.style.width = "150px";
      img.style.height = "45px";
      console.log("getSignatureCanvas Signature updated:", val);

      if (this.currentSignatureElement) {
        this.currentSignatureElement.innerHTML = "";
        this.currentSignatureElement.appendChild(img);
      } else {
        console.log("No currentSignatureElement found.");
      }
      
      this.currentSignatureElement.addEventListener("click", this.onSignatureClick);
      console.log("getSignatueCanvas Signature updated:", val);
    },
    getSignatureFont(font) {
      if (this.currentSignatureElement) {
        this.currentSignatureElement.style.fontFamily = font;
        console.log("Font updated to:", font);
      }
    },
    // onDropClonedElement(event){
    //     console.log(event.target.className,"onDropClonedElement", event);
    //   },
    //   onDragStartClone(event){
    //     console.log(event.target.className,"onDragStartClone", event);
    //     event.dataTransfer.setData("text", event.target.id);
    //   },
    //   onDragEndClone(event){
    //     console.log(event.target.className,"onDragEndClone", event);
    //   },
  },
};
</script>

<style lang="scss">
#app {
  section:hover {
    //   cursor: pointer;
    position: relative;
  }
}
.drag-signature {
  width: 183px;
  height: 46px;
  padding: 12px 0;
  border-radius: 4px 0 0 0;
  border: 1px solid black;
  margin-bottom: 12px;
  position: relative;
}
</style>
